import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineChart1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLineChart1"><Path d="M5 19V3H3V21H22V19H5Z" fill="currentColor"/><Path d="M15 17V4H13V17H15Z" fill="currentColor"/><Path d="M10 17V10H8V17H10Z" fill="currentColor"/><Path d="M20 17V12H18V17H20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLineChart1;
